import { userErrorFragment } from './fragmentGeneral.gql';
import cartFragment from './fragmentCart.gql';

const cartLinesUpdate = (
	`mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
		cartLinesUpdate(cartId: $cartId, lines: $lines) {
			userErrors ${userErrorFragment}
			cart ${cartFragment}
		}
	}`
);

export default cartLinesUpdate;
